module.exports = "/img/spartan_bg.jpg?1b3390e4fd5fbcbb3c4925a2410a5a7d";